export default [
  {
    path: "/transaksi/keranjang",
    name: "transaksi/keranjang",
    component: () => import("@/views/menu/transaksi/keranjang/Index.vue"),
    meta: {
      pageTitle: "Transaksi",
      requireAuth: true,
      breadcrumb: [
        {
          text: "Keranjang",
          active: true,
        },
      ],
    },
  },
  {
    path: "/transaksi/invoice",
    name: "transaksi/invoice",
    component: () => import("@/views/menu/transaksi/invoice/Index.vue"),
    meta: {
      pageTitle: "Transaksi",
      requireAuth: true,
      breadcrumb: [
        {
          text: "History Bayar",
          active: true,
        },
      ],
    },
  },
  {
    path: "/transaksi/invoice/:id",
    name: "transaksi/invoice-detail",
    component: () => import("@/views/menu/transaksi/invoice/Detail.vue"),
    meta: {
      pageTitle: "Transaksi",
      requireAuth: true,
      breadcrumb: [
        {
          text: "History Bayar",
          active: false,
          to: { name: "transaksi/invoice" },
        },
        {
          text: "Detail History Bayar",
          active: true,
        },
      ],
    },
  },
];
